import globals from '../index';

const isLocaleUnAwareGlobalSource = (globalSource) => {
  const global = globals.accessors.getGlobalBySource(globalSource);
  return Boolean(global && global.localeUnaware);
};

export default isLocaleUnAwareGlobalSource;
